<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      coupon: {
        type: String,
        default: null
      }
    }
  }
</script>
<template>
  <h3 :class="$style.sectionTitle">
    {{ title }}
    <p v-if="coupon" class="text-base md:text-lg color-gray-5 my-2">序號：<span class="color-primary">{{ coupon }}</span></p>
    <span class="bottom-line"></span>
  </h3>
</template>
<style lang="scss" module>
  .sectionTitle {
    position: relative;
    margin-bottom: 3.8125rem;
    font-size: 1.5rem;
    @include max-lg {
      font-size: 1.5rem;
    }
    @include max-md {
      font-size: 1.25rem;
    }

    &::before {
      position: absolute;
      bottom: -20px;
      left: 0;
      width: 5px;
      height: 5px;
      content: '';
      background-color: $color-primary;
      border-radius: 50%;
      @include max-md {
        bottom: -0.875rem;
      }
    }

    &::after {
      position: absolute;
      bottom: -20px;
      left: 10px;
      width: 5px;
      height: 5px;
      content: '';
      background-color: $color-primary;
      border-radius: 50%;
      @include max-md {
        bottom: -0.875rem;
      }
    }

    :global {
      .bottom-line {
        position: absolute;
        bottom: -20px;
        left: 20px;
        width: 30px;
        height: 5px;
        background-color: $color-primary;
        border-radius: 4px;
        @include max-md {
          bottom: -0.875rem;
        }
      }
      .sectionTitle2_coupon {
        
      }
    }
  }
</style>
